// UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAppConfig} from '../services/appConfig';

const AppConfigContext = createContext(null);

export const AppConfigProvider = ({ children }) => {
  const [appConfig, setConfig] = useState(null);

  useEffect(() => {
    const getAppConfigInfo = async () => {
      try {
        const app_config_data = await getAppConfig();
        setConfig(app_config_data);
      } catch (error) {
        console.error('Error fetching app config details:', error);
        // removeTokens();
        // window.location.replace('/login');
      }
    };

    getAppConfigInfo();
  }, []);

  return (
    <AppConfigContext.Provider value={{ appConfig }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useConfig = () => useContext(AppConfigContext);
